var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isStockStorage)?_c('div',[_c('CustomDataGrid',{attrs:{"hasIndexGroup":false,"items":_vm.items,"headers":[
        { dataField: 'obra', caption: 'Obra' },
        { dataField: 'ubicacion', caption: 'Ubicacion' },
        { dataField: 'familia', caption: 'Familia' },
        { dataField: 'referencia', caption: 'Referencia' },
        { dataField: 'descripcion', caption: 'Descripcion' },
        // { dataField: 'precio_compra', caption: 'Precio compra' },
        { dataField: 'stock', caption: 'Stock' },
        { dataField: 'embalaje', caption: 'Embalaje' },
        { dataField: 'unidades_caja', caption: 'Unidades caja' },
        { dataField: 'seriado', caption: 'Seriado' },
    ]}})],1):_c('div',[_c('CustomDataGrid',{attrs:{"hasIndexGroup":true,"items":_vm.items,"headers":[
        { dataField: 'brigada', caption: 'Brigada', group: 0 },
        { dataField: 'obra', caption: 'Obra' },
        { dataField: 'nombrefamilia', caption: 'Familia' },
        { dataField: 'referencia', caption: 'Referencia' },
        { dataField: 'descripcion', caption: 'Descripcion' },
        // { dataField: 'precio_compra', caption: 'Precio compra' },
        { dataField: 'stock', caption: 'Stock' },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }